import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { AttemptFormValues } from 'src/models/Attempt.model';
import Attempt from '../Layouts/AttemptForm';
import { useAddAttemptMutation } from 'src/services/AttemptService';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
};

const AddAttemptWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: AttemptFormValues = {
    attempt: '',
  };

  // Validation Schema
  const validationSchema = object().shape({
    attempt: string().required('Please enter attempt'),
  });

  const [addAttempt] = useAddAttemptMutation()

  // Handle Submit
  const handleSubmit = (
    values: AttemptFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AttemptFormValues>
  ) => {
    addAttempt(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm()
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };


  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Attempt formikProps={formikProps} onClose={onClose}  formType ="ADD" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddAttemptWrapper;